<template>
<!-- Mobile Only -->
  <div class="page-title py-5 bg-custom-gradient position-relative">
    <!-- User -->
    <div class="user d-lg-none d-flex mt-5 align-items-center justify-content-center flex-column position-absolute top-100 start-50 translate-middle w-100 px-3">
      <div class="avatar mt-lg-0 mt-3 position-relative">
        <img src="@/assets/images/msaaq.svg" width="152" alt="" />
      </div>
      <div class="d-flex align-items-center mt-1">
        <div class="fs-6 text-primary fw-bold">مساق</div>
      </div>
      <div class="fs-14px text-secondary text-center mb-5">هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى</div>
    </div>
  </div>
  <!-- End mobile -->
  <div class="container">
    <!-- Mobile -->
    <div class="clearfix d-lg-none d-block"></div>
    <div class="d-lg-none d-block border-top border-2 my-3"></div>
    <!-- end Mobile only -->
    <div class="my-lg-5 my-0"></div>
    <div class="row gap-3 meeting-body pb-lg-3">
      <div class="col-12 mx-auto px-0">
        <!-- Desktop Only -->
        <div class="bg-custom-gradient meeting-card d-lg-flex d-none align-items-center gap-3 py-3">
          <img src="@/assets/images/userbig.png" class="mx-3" width="90" alt="">
          <div class="d-flex flex-column">
            <span class="fs-4 text-white fw-bold">مدحت عودة</span>
            <span class="fs-14px text-white w-75">هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى</span>
          </div>
        </div>
      </div>
      <h5 class="text-dark fw-bold fs-14px">اختر الخطة الأنسب</h5>
      <MeetingCard v-for="meeting in meetings" :meeting="meeting" :key="meeting.id"  />
    </div>
  </div>
</template>

<script>
import MeetingCard from '@/components/MeetingCard.vue'
import { ref } from '@vue/reactivity'
export default {
  name: 'MeetingsIndex',
  components:{MeetingCard},
  setup() {

    const meetings = ref([
      {
        id: 1,
        title:'إستشارة على الموقع',
        subtitle:'اقرب موعد 23 ابريل',
        platform: 'zoom',
        duration: '30 د',
        price: '125$'
      },
      {
        id: 2,
        title:'إستشارة على الموقع',
        subtitle:'اقرب موعد 23 ابريل',
        platform: 'zoom',
        duration: '30 د',
        price: '125$'
      },
      {
        id: 3,
        title:'إستشارة على الموقع',
        subtitle:'اقرب موعد 23 ابريل',
        platform: 'zoom',
        duration: '30 د',
        price: '125$'
      },
      {
        id: 4,
        title:'إستشارة على الموقع',
        subtitle:'اقرب موعد 23 ابريل',
        platform: 'zoom',
        duration: '30 د',
        price: '125$'
      }
    ])

    return {meetings}
  },
}
</script>

<style>
</style>